import { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { LABEL_COLORS } from './task-board.constants';

type Props = {
  value: string;
  onChange: (color: string) => void;
};

const LabelColorPicker = ({ value, onChange }: Props) => {
  const [open, setOpen] = useState(false);
  const [popoverPos, setPopoverPos] = useState({ top: 0, left: 0 });
  const triggerRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (!open) return;
    const handle = (e: MouseEvent) => {
      const target = e.target as Element;
      if (
        triggerRef.current &&
        !triggerRef.current.contains(target as Node) &&
        !target.closest?.('.task-board__color-picker-popover')
      ) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handle);
    return () => document.removeEventListener('mousedown', handle);
  }, [open]);

  const handleTriggerClick = () => {
    if (!open && triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      setPopoverPos({ top: rect.bottom + 6, left: rect.left });
    }
    setOpen((v) => !v);
  };

  const popover = (
    <div
      className="task-board__color-picker-popover"
      style={{ position: 'fixed', top: popoverPos.top, left: popoverPos.left, zIndex: 99999999999999 }}
    >
      <div className="task-board__color-picker-popover-title">Select a color</div>
      <div className="task-board__color-picker-popover-grid">
        {LABEL_COLORS.map((c) => (
          <button
            key={c.value}
            type="button"
            title={c.name}
            className={`task-board__color-picker-popover-swatch${
              value === c.value ? ' task-board__color-picker-popover-swatch--selected' : ''
            }`}
            style={{ backgroundColor: c.value }}
            onClick={() => {
              onChange(c.value);
              setOpen(false);
            }}
          >
            {value === c.value && <i className="fas fa-check" />}
          </button>
        ))}
      </div>
    </div>
  );

  return (
    <>
      <button
        ref={triggerRef}
        type="button"
        className="task-board__color-picker-trigger"
        style={{ backgroundColor: value || '#6b7280' }}
        onClick={handleTriggerClick}
        title="Select a color"
      />
      {open && ReactDOM.createPortal(popover, document.body)}
    </>
  );
};

export default LabelColorPicker;
